import React, { useEffect, useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { FiDownload } from 'react-icons/fi';
import { IoIosArrowBack } from 'react-icons/io';
import { MdError } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { Button, CircularProgress } from '@material-ui/core';
import { Form } from '@unform/web';

import addImg from '~/assets/add.svg';
import deleteImg from '~/assets/delete.svg';
import vectorImg from '~/assets/Vector.svg';
import File from '~/components/Form/File';
import Modal from '~/components/Modal';
import { useAuth } from '~/hooks/auth';
import { useFiles } from '~/hooks/files';
import { IState } from '~/store';
import {
  getDataListRequest,
  getMetadataFileByNameDataListRequest,
  getMetadataFileDataListRequest,
} from '~/store/modules/dataList/actions';
import {
  createImportProcessRequest,
  getLatestImportProcessRequest,
} from '~/store/modules/importProcesses/actions';

import MaterialLayout from '../EditDataList/Layout/MaterialLayout';
import useStyles, {
  ErrorBody,
  ErrorContainer,
  ErrorFileLink,
  ErrorHeader,
  ModalSubmitButton,
} from './styles';
import {
  Container,
  Title,
  ButtonsContent,
  Subtitle,
  ButtonOption,
  ModalContainer,
  ModalContentContainer,
  ModalContent,
} from './styles';

enum ButtonOptions {
  INSERT = 'INSERT',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
}

const EditDataListData = () => {
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [typeOperation, setTypeOperation] = useState<ButtonOptions>(
    ButtonOptions.INSERT,
  );

  const dataList = useSelector((state: IState) => state.dataList.dataList);
  const importProcess = useSelector(
    (state: IState) => state.importProcesses.importProcess,
  );
  const loadingCreate = useSelector(
    (state: IState) => state.importProcesses.loadingCreate,
  );
  const loadingGetLatest = useSelector(
    (state: IState) => state.importProcesses.loadingGetLatest,
  );

  const { user } = useAuth();
  const { id } = useParams<{ id: string }>();
  const { uploadedFiles, resetUploadedFiles } = useFiles();

  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const handleBackHistory = () => {
    history.goBack();
  };

  const handleGetFile = () => {
    dispatch(getMetadataFileDataListRequest(id));
  };

  const handleGetFileByName = (fileName: string) => {
    dispatch(getMetadataFileByNameDataListRequest(fileName));
  };

  const cardSelect = {
    border: '2px solid #eb0045',
  };

  const handleModal = () => {
    if (
      typeOperation === ButtonOptions.DELETE ||
      typeOperation === ButtonOptions.UPDATE
    ) {
      setConfirmationModal(true);
    } else {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (uploadedFiles.length > 0) {
      const type = 'DATALIST';
      const urlPath = '/data-lists';
      dispatch(
        createImportProcessRequest(
          id,
          type,
          typeOperation,
          uploadedFiles[0].key,
          user.personId,
          urlPath,
        ),
      );
    }
    setConfirmationModal(false);
  };

  useEffect(() => {
    resetUploadedFiles();
    dispatch(getLatestImportProcessRequest(id));
    dispatch(getDataListRequest(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Title onClick={handleBackHistory}>
        <IoIosArrowBack
          style={{ background: '#fff', color: '#EB0045', borderRadius: '50%' }}
          size={16}
        />
        <span>Voltar para cadastros</span>
      </Title>
      <h1>Editar dados</h1>
      <div>
        <h1>Edição do Cadastro: {dataList?.name}</h1>
        <Subtitle>
          <p>Confira se você tem o arquivo atualizado.</p>
          <button type="button" onClick={() => handleGetFile()}>
            <FiDownload size={12} color="#EB0045" />
            <span>Baixar arquivo atualizado</span>
          </button>
        </Subtitle>
        <h1>Tipo da edição</h1>
        <ButtonsContent>
          <ButtonOption
            style={{
              ...(typeOperation === ButtonOptions.INSERT && cardSelect),
            }}
            onClick={() => {
              setTypeOperation(ButtonOptions.INSERT);
            }}
          >
            <img src={addImg} alt="" />
            <h2>Adicionar dados</h2>
            <p>Todos os itens informados serão adicionados.</p>
          </ButtonOption>
          <ButtonOption
            style={{
              ...(typeOperation === ButtonOptions.DELETE && cardSelect),
            }}
            onClick={() => {
              setTypeOperation(ButtonOptions.DELETE);
            }}
          >
            <img src={deleteImg} alt="" />
            <h2>Excluir dados</h2>
            <p>Apenas os dados informados serão excluídos.</p>
          </ButtonOption>
          <ButtonOption
            style={{
              ...(typeOperation === ButtonOptions.UPDATE && cardSelect),
            }}
            onClick={() => {
              setTypeOperation(ButtonOptions.UPDATE);
            }}
          >
            <img src={vectorImg} alt="" />
            <h2>Substituir dados</h2>
            <p>Substitua o arquivo completo do cadastro.</p>
          </ButtonOption>
        </ButtonsContent>
        <h2>Arquivo com os dados</h2>

        {!loadingGetLatest && importProcess?.status === 'ERROR' && (
          <ErrorContainer>
            <ErrorHeader>
              <div style={{ display: 'flex' }}>
                <MdError size={16} color="#C11E1E" className="mdError" />
                <p>
                  Alguns erros foram encontrados e precisam ser corrigidos para
                  prosseguir.
                </p>
              </div>
              <ErrorFileLink
                onClick={() => handleGetFileByName(importProcess.filePath)}
              >
                <FiDownload size={16} color="#006e99" />
                Clique aqui para baixar arquivo com erros
              </ErrorFileLink>
            </ErrorHeader>
            <ErrorBody>
              {Array.isArray(importProcess.log) ? (
                importProcess.log.map((errorMessage) => <li>{errorMessage}</li>)
              ) : (
                <li>{importProcess.log}</li>
              )}
            </ErrorBody>
          </ErrorContainer>
        )}
        <Form onSubmit={() => {}}>
          <File
            label="Arquivo"
            message="Clique ou arraste um arquivo aqui (10mb max)..."
            acceptedTypes={[
              '.csv',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ]}
            multiple={false}
          />
        </Form>
        <div className={classes.buttons}>
          <Button onClick={handleBackHistory} className={classes.button}>
            Cancelar
          </Button>
          <div className={classes.wrapper}>
            <Button
              disabled={uploadedFiles.length < 1}
              type="submit"
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleModal}
            >
              {loadingCreate ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Salvar'
              )}
            </Button>
          </div>
        </div>
        <ModalContainer>
          <Modal
            title=" "
            open={confirmationModal}
            modalState={(opened) => setConfirmationModal(opened)}
          >
            <ModalContentContainer>
              <FiAlertTriangle size={60} color="#EB0045" />
              <ModalContent>
                {typeOperation === ButtonOptions.UPDATE && (
                  <>
                    <h2>Substituir os dados?</h2>
                    <p>
                      Ao continuar, todos os dados atuais serão substituidos
                      pelos novos.
                    </p>
                  </>
                )}
                {typeOperation === ButtonOptions.DELETE && (
                  <>
                    <h2>Deletar os dados?</h2>
                    <p>Apenas os dados informados serão excluídos.</p>
                  </>
                )}
                <div>
                  <button
                    type="button"
                    onClick={() => {
                      setConfirmationModal(false);
                    }}
                  >
                    CANCELAR
                  </button>
                  <ModalSubmitButton type="button" onClick={handleSubmit}>
                    CONTINUAR
                  </ModalSubmitButton>
                </div>
              </ModalContent>
            </ModalContentContainer>
          </Modal>
        </ModalContainer>
      </div>
    </Container>
  );
};

export default EditDataListData;
